export const styles = {
  container: {
    width: "100%",
    height: "calc(100vh - 100px)",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    p: { xs: 1.5, sm: 2, md: 3 },
    boxSizing: "border-box",
    overflow: "hidden",
    gap: 3,
  },

  formPanel: {
    flex: { xs: "none", md: 1 },
    display: "flex",
    flexDirection: "column",
    borderRadius: 3,
    border: "1px solid",
    borderColor: "divider",
    overflow: "hidden",
  },

  formHeader: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 2.5,
    py: 2,
    borderBottom: "1px solid",
    borderColor: "divider",
    bgcolor: "rgba(208, 116, 155, 0.04)",
  },

  formContent: {
    p: 2.5,
    display: "flex",
    flexDirection: "column",
    gap: 2.5,
    flex: 1,
    overflowY: "auto",
  },

  channelChip: (isSelected, theme) => ({
    fontWeight: isSelected ? 700 : 400,
    borderColor: isSelected
      ? theme.palette.primary.main
      : "rgba(0,0,0,0.2)",
    bgcolor: isSelected
      ? "rgba(208, 116, 155, 0.1)"
      : "transparent",
    color: isSelected
      ? theme.palette.primary.main
      : "text.secondary",
    "&:hover": {
      bgcolor: "rgba(208, 116, 155, 0.08)",
    },
  }),

  sendButton: (theme) => ({
    borderRadius: 2,
    textTransform: "none",
    fontWeight: 600,
    py: 1.5,
    fontSize: "1rem",
    bgcolor: theme.palette.primary.main,
    "&:hover": { bgcolor: theme.palette.primary.dark },
  }),

  historyPanel: {
    flex: { xs: "none", md: 1 },
    display: "flex",
    flexDirection: "column",
    borderRadius: 3,
    border: "1px solid",
    borderColor: "divider",
    overflow: "hidden",
    maxHeight: { xs: 300, md: "100%" },
  },

  historyHeader: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 2.5,
    py: 2,
    borderBottom: "1px solid",
    borderColor: "divider",
    bgcolor: "rgba(0,0,0,0.01)",
    flexShrink: 0,
  },

  historyList: {
    flex: 1,
    overflowY: "auto",
    p: 1.5,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    "&::-webkit-scrollbar": { width: 6 },
    "&::-webkit-scrollbar-thumb": {
      bgcolor: "rgba(0,0,0,0.1)",
      borderRadius: 3,
    },
  },

  historyItem: {
    p: 2,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    transition: "background-color 0.2s",
    animation: "fadeIn 0.3s ease-in",
    "@keyframes fadeIn": {
      from: { opacity: 0, transform: "translateY(8px)" },
      to: { opacity: 1, transform: "translateY(0)" },
    },
  },

  emptyHistory: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    opacity: 0.4,
    gap: 1,
  },

  successAlert: {
    position: "fixed",
    top: 80,
    right: 24,
    zIndex: 1300,
    minWidth: 280,
    borderRadius: 2,
    boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
  },
};
